import React from "react";
import { KpiCard, KpiStrip } from "../../../ui";
import { Summary, formatCount, formatDate, formatMoney, formatPercent } from "../salesData";

interface LifetimeStripProps {
  summary: Summary;
  currency: string;
}

/** All-time totals. Ignores every filter on purpose: this is the fixed
 * reference the filtered numbers below are read against. */
export default function LifetimeStrip({ summary, currency }: LifetimeStripProps) {
  return (
    <KpiStrip max={4}>
      <KpiCard
        title="Lifetime GMV"
        value={formatMoney(summary.gmv, currency)}
        sub={summary.firstSale ? `selling since ${formatDate(summary.firstSale)}` : undefined}
        help="Items + delivery − discounts, excluding refunded items"
      />
      <KpiCard
        title="Platform revenue"
        value={formatMoney(summary.platformRevenue, currency)}
        sub={`take rate ${formatPercent(summary.takeRate)}`}
        help={`Take rate ${formatPercent(summary.takeRate)} of GMV`}
      />
      <KpiCard
        title="Orders"
        value={formatCount(summary.orders)}
        sub={`${formatCount(summary.units)} units · avg ${formatMoney(summary.aov, currency)}`}
      />
      <KpiCard
        title="Buyers"
        value={formatCount(summary.buyers)}
        sub={`${formatPercent(summary.repeatBuyerRate)} repeat · ${formatCount(summary.sellers)} sellers with sales`}
        help={`${formatPercent(summary.repeatBuyerRate)} have ordered more than once`}
      />
    </KpiStrip>
  );
}
